import React, { useState } from "react";
import { useSnackBar } from "../../../hooks/useSnackBar";

import TabsComponent from "../../../Components/Common/TabsComponent";
import Locations from "./Locations";
import StorageMap from "./StorageMap";
import { useTranslation } from "react-i18next";

const StorageLocations = () => {
  const { t } = useTranslation("warehouse");
  // new states
  const [tab, setTab] = useState("locations");

  const setSnack = useSnackBar();

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "0px 5px" }}
    >
      <TabsComponent
        items={[
          {
            label: t("locations.locations"),
            style: { fontWeight: "bold" },
            value: "locations",
          },
          { label: t("locations.graph"), style: { fontWeight: "bold" }, value: "graph" },
        ]}
        tab={tab}
        handleTabChange={handleTabChange}
      />
      {tab === "locations" && <Locations setSnack={setSnack} />}
      {tab === "graph" && <StorageMap />}
    </div>
  );
};

export default StorageLocations;
